import { gql } from '@apollo/client';

export const GET_RESOURCES = gql`
  query GetResources($input: GetResourcesRequest!) {
    getResources(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
        created
        modified
        deleted
        uri
        thumbnail_uri
        name
        type
        tags
        categories
        size
        source
        description
        file_extension
        alias
        allow_download
        transcoding_status
      }
    }
  }
`;
